var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"rotate":-90,"size":100,"width":13,"value":_vm.value,"color":"primary"}},[_vm._v(" "+_vm._s(_vm.value)+" % ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }